export default __webpack_public_path__ + "static/media/coach_guideme_lancingkit_lancets100_strips150_gray@1x.31a381d9.webp";